import { APIGetCountryAndStateFullNames } from '../_components/_api-get-country-and-state-full-names';

const COUNTRY = ".js-country";
const STATE = ".js-state";
const DISTRICT = ".js-district";
const FORM_ITEM = ".form-item";
const LOADING_CLASS_NAME = "is-loading";
const DISABLED_CLASS_NAME = "is-disabled";

window.$ = jQuery;

$( document ).ready( function () {

	let upload_cities_list = function () {
        if ( $( COUNTRY ).length == 0 ) {
            return;
        }
		let $parentFormItem = $( COUNTRY ).parent( FORM_ITEM );

		$.ajax( {
			url: gocoderzAjax.url,
			type: "post",
			data: {
				action: "get_countries_list",
				nonce: gocoderzAjax.nonce
			},

			beforeSend: function () {
				$parentFormItem.addClass( LOADING_CLASS_NAME );
			},

			error: function ( response ) {
				$( COUNTRY ).select2( {
					dropdownParent: $( COUNTRY ).closest( ".js-select-wrapper" )
					                            .find( ".js-select-dropdown" )
				} );
				$parentFormItem.find( ".select2-selection" ).addClass( "error-field" );
				$parentFormItem.find( ".form-error" ).text( "Something Wrong" )
				               .css( "display", "block" );
				console.error( response );
				$parentFormItem.removeClass( LOADING_CLASS_NAME );
			},

			success: function ( response ) {
				let data = JSON.parse( response );
				let data_options = [];
				let other_attr = "";
				let usa_option = "";

				let filteredData = data.data;

				filteredData.sort( function ( a, b ) {
					if ( a.name > b.name ) {
						return 1;
					}
					if ( a.name < b.name ) {
						return -1;
					}
					return 0;
				} );

				// Parse Data
				for ( let i = 0; i < filteredData.length; i++ ) {
					let data_id = filteredData[ i ][ "alpha2" ];
					let data_name = filteredData[ i ][ "name" ];

					// Check Other Parameter
					if ( "Other" === data_name ) {
						other_attr = {
							id: data_id,
							text: data_name
						};

						continue;
					}

					if ( "US" === data_id ) {
						usa_option = {
							id: data_id,
							text: data_name
						};

						continue;
					}

					// Add to Cities List Array
					data_options.push( {
						id: data_id,
						text: data_name
					} );
				}

				// Add Other in the End of List Array
				if ( "" !== other_attr ) {
					data_options.push( other_attr );
				}

				// Add US first
				if ( "" !== usa_option ) {
					data_options.unshift( usa_option );
				}

				// Update Select List
				$( COUNTRY ).select2( {
					data: data_options,
					dropdownParent: $( COUNTRY ).closest( ".js-select-wrapper" )
					                            .find( ".js-select-dropdown" )
				} );

				$parentFormItem.find( ".error-message" ).remove();
				$parentFormItem.removeClass( LOADING_CLASS_NAME );

                $( STATE ).parent( FORM_ITEM ).removeClass( LOADING_CLASS_NAME );
                $( STATE ).parent( FORM_ITEM ).addClass( DISABLED_CLASS_NAME );
                APIGetCountryAndStateFullNames( true, false );
			}
		} );
	};

	let upload_states_list = function ( value ) {
    	if ( $( STATE ).length == 0 ) {
    		return;
    	}
		let $parentFormItem = $( STATE ).parent( FORM_ITEM );

		$.ajax( {
			url: gocoderzAjax.url,
			type: "post",
			data: {
				country: value,
				action: "get_states_list",
				nonce: gocoderzAjax.nonce
			},

			beforeSend: function () {
				$parentFormItem.addClass( LOADING_CLASS_NAME );
				// Clear Cities
				$( STATE ).val( null ).trigger( "change" );
				$( STATE + " option" ).remove();
			},

			error: function ( response ) {
				$( STATE ).select2( {
					dropdownParent: $( STATE ).closest( ".js-select-wrapper" )
					                          .find( ".js-select-dropdown" )
				} );
				$parentFormItem.find( ".select2-selection" ).addClass( "error-field" );
				$parentFormItem.find( ".form-error" ).text( "Something Wrong" )
				               .css( "display", "block" );
				console.error( response );
				$parentFormItem.removeClass( LOADING_CLASS_NAME );
			},

			success: function ( response ) {
				let data = JSON.parse( response );
				let data_options = [];
				let other_attr = "";

				data_options.push( {
					id: "",
					text: ""
				} );

				let filteredData = data.data;

				filteredData.sort( function ( a, b ) {
					if ( a.name > b.name ) {
						return 1;
					}
					if ( a.name < b.name ) {
						return -1;
					}
					return 0;
				} );

				// Parse Data
				for ( let i = 0; i < filteredData.length; i++ ) {
					let data_code = filteredData[ i ][ "code" ];
					let data_name = filteredData[ i ][ "name" ];

					if ( "US" !== $( COUNTRY ).val() && "OTHER" === data_code ) {
						other_attr = {
							id: data_code,
							text: data_name,
							selected: true
						};
					} else {
						data_options.push( {
							id: data_code,
							text: data_name
						} );
					}
				}

				// Add Other in the End of List Array
				if ( "" !== other_attr ) {
					data_options.push( other_attr );
				}

				// Update Select List
				$( STATE ).select2( {
					data: data_options,
					dropdownParent: $( STATE ).closest( ".js-select-wrapper" )
					                          .find( ".js-select-dropdown" )
				} );
				$( STATE ).trigger( {
					type: "select2:select"
				} );

				$parentFormItem.find( ".error-message" ).remove();
				$parentFormItem.removeClass( LOADING_CLASS_NAME );

                APIGetCountryAndStateFullNames( false, true );
			}

		} );
	};

	let upload_district_list = function ( value ) {
    	if ( $( DISTRICT ).length == 0 || value == '' ) {
    		return;
    	}
		let $parentFormItem = $( DISTRICT ).parent( FORM_ITEM );

		$.ajax( {
			url: gocoderzAjax.url,
			type: "post",
			data: {
				state: value,
				action: "get_district_list",
				nonce: gocoderzAjax.nonce
			},

			beforeSend: function () {
				$parentFormItem.addClass( LOADING_CLASS_NAME );
				// Clear Cities
				$( DISTRICT ).val( null ).trigger( "change" );
				$( DISTRICT + " option" ).remove();
			},

			error: function ( response ) {
				$( DISTRICT ).select2( {
					dropdownParent: $( DISTRICT ).closest( ".js-select-wrapper" )
					                          .find( ".js-select-dropdown" )
				} );
				$parentFormItem.find( ".select2-selection" ).addClass( "error-field" );
				$parentFormItem.find( ".form-error" ).text( "Something Wrong" )
				               .css( "display", "block" );
				console.error( response );
				$parentFormItem.removeClass( LOADING_CLASS_NAME );
			},

			success: function ( response ) {
				var data = JSON.parse(response);
				var data_options = new Array();

				data_options.push( {
					id: "",
					text: ""
				} );


				// Parse Data
				for (var i = 0; i < data.length; i++) {
					var data_name  = data[i]['district-name'];
					var other_attr = '';

					data_options.push({
						id : data_name,
						text : data_name + ', ' + value
					});
				}

				if( data.length !== 0 ) {
					data_options.push({
						id : 'other',
						text : 'Other'
					});
				}

				// Update Select List
				$( DISTRICT ).select2( {
					data: data_options,
					dropdownParent: $( STATE ).closest( ".js-select-wrapper" )
					                          .find( ".js-select-dropdown" )
				} );
				$( DISTRICT ).trigger( {
					type: "select2:select"
				} );

				$parentFormItem.find( ".error-message" ).remove();
				$parentFormItem.removeClass( LOADING_CLASS_NAME );
				$parentFormItem.removeClass( DISABLED_CLASS_NAME );
			}

		} );
	};
	

	upload_cities_list();

	// Change Billing Action
	$( COUNTRY ).on( "change", function ( event ) {
		let value = $( event.target ).val();

        if ( value == "US" ) {
            upload_states_list( value );
        } else {
			// State
            $( STATE ).select2( {
                data: [{
                    id: "OTHER",
                    text: "Other"
                }]
            } );
            $( STATE ).val( "OTHER" );
            $( STATE ).trigger( "change" );
        }
	} );

	$( STATE ).on( "change", function ( event ) {
		let value = $( event.target ).val();
		
		if( value !== "OTHER" ) {
			upload_district_list( value );
		} else {
			let $parentFormItem = $( DISTRICT ).parent( FORM_ITEM );

			// District
			$( DISTRICT ).select2( {
                data: [{
                    id: "OTHER",
                    text: "Other"
                }]
            } );
            $( DISTRICT ).val( "OTHER" );
            $( DISTRICT ).trigger( "change" );

			$parentFormItem.addClass( DISABLED_CLASS_NAME );
		}
	} );

	// Billing No Result Text Message
	$( STATE ).select2( {
		"language": {
			"noResults": function () {
				return "First Select a Country";
			}
		},
		dropdownParent: $( STATE ).closest( ".js-select-wrapper" ).find( ".js-select-dropdown" )
	} );
} );